import Vue from 'vue'
import App from './App.vue'
import '@bplus-common/components-vue2/style.css'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
